import "core-js/modules/es6.function.name";
import request from "@/util/http"; // 系统文件上传

export var sysFileUpload = function sysFileUpload(param) {
  var fileName = param.get("file").name;

  if (fileName.length <= 30) {
    return new Promise(function (resolve, reject) {
      request({
        headers: {
          "Content-Type": "multipart/form-data"
        },
        url: "/admin/file/upload",
        method: "post",
        data: param
      }).then(function (res) {
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  } else {
    return Promise.resolve({
      data: {
        code: 1,
        msg: "文件名过长，请重新修改后上传"
      }
    });
  }
}; // 文件下载

export var handleDownload = function handleDownload(id) {
  return "/admin/file/download/".concat(id);
}; // 系统文件删除

export var sysFileDelete = function sysFileDelete(id) {
  return request({
    url: "/admin/file/delete/".concat(id),
    method: "delete"
  });
}; // 服务文件上传

export var serveFileUpload = function serveFileUpload(param) {
  var fileName = param.get("file").name;

  if (fileName.length <= 30) {
    return new Promise(function (resolve, reject) {
      request({
        headers: {
          "Content-Type": "multipart/form-data"
        },
        url: "/admin/serveFile/upload",
        method: "post",
        data: param
      }).then(function (res) {
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  } else {
    return Promise.resolve({
      data: {
        code: 1,
        msg: "文件名过长，请重新修改后上传"
      }
    });
  }
}; // 文件下载

export var handleserveFileDownload = function handleserveFileDownload(id) {
  return "/admin/serveFile/download/".concat(id);
}; // 服务文件删除

export var serveFileDelete = function serveFileDelete(id) {
  return request({
    url: "/admin/serveFile/delete/".concat(id),
    method: "delete"
  });
}; // 查询所有服务列表

export var getHallServeList = function getHallServeList(params) {
  return request({
    url: "/admin/tHallServe/list",
    method: "get",
    params: params
  });
}; // 角色列表查询

export var getRoleList = function getRoleList() {
  return request({
    url: "/admin/role/list",
    method: "get"
  });
}; // 部门树形数据查询

export var getDeptTree = function getDeptTree(params) {
  return request({
    url: "/admin/dept/tree",
    method: "get",
    params: params || {}
  });
}; // 部门树形数据查询

export var moveDept = function moveDept(params) {
  return request({
    url: "/admin/dept/move",
    method: "post",
    params: params
  });
}; // 分页查询用户

export var getUserPageTwo = function getUserPageTwo(params) {
  return request({
    url: "/admin/user/page2",
    method: "get",
    params: params
  });
};